import { useParams } from "react-router-dom";

import { SubProfile } from "~components/swing-react-components";

import { useSubProfile } from "./hooks";

export function SubProfilePage() {
  const { subId }: { subId: string } = useParams();
  const subProfileData = useSubProfile(subId);

  return (
    <div className="page">
      <SubProfile {...subProfileData} isSwingHero={subProfileData?.stats?.isSwingHero} />
    </div>
  );
}
